import React, { useState, useEffect, useRef, useContext } from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { useQuery, useMutation } from 'react-query';

import {
  CredusButton,
  CredusInput,
  CredusText,
  CredusSelect,
  OptionType,
  CredusTextArea,
} from 'ui';

import { TestContext } from '../../../../../contexts/TestContext';
import PageLoader from '../../../PageLoader';
import testApi, { Category, Subject } from '../../../../../api/test';
import { objectToFormData, saveAs } from '../../../../../utils/helpers';
import ComponentLoader from '../../../ComponentLoader';

interface CreateTestProps {
  createTest: boolean;
  setCreateTest: React.Dispatch<React.SetStateAction<boolean>>;
  setTestReUpload: React.Dispatch<React.SetStateAction<boolean>>;
}
interface ExamCategoryProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setTestId: React.Dispatch<React.SetStateAction<number>>;
}
interface QuestionTemplateProps {
  setCreateTest: React.Dispatch<React.SetStateAction<boolean>>;
  setTestReUpload: React.Dispatch<React.SetStateAction<boolean>>;
  TestId: number;
}

const ExamCategory = ({ setStep, setTestId }: ExamCategoryProps) => {
  const [loading, setLoading] = useState(false);
  const [categoryId, setcategoryId] = useState(0);
  const [subjectId, setSubjectId] = useState(0);
  const [code, setCode] = useState('');
  const [description, setDescription] = useState('');
  const [subject, setSubject] = useState<Subject[]>([]);
  const [subjectOptions, setSubjectOptions] = useState([
    { optionName: '', optionValue: '', optionId: '' },
  ]);
  const { setTestId: setId, setTestCategory } = useContext(TestContext);
  const { data, isLoading } = useQuery(['testCategories', 1], () =>
    testApi.getTestCategories(1)
  );

  const { mutate } = useMutation(testApi.createTest, {
    onMutate: () => setLoading(true),
    onSuccess: (data) => {
      setLoading(false);
      setId(Number(data?.data));
      setTestId(Number(data?.data));
      setStep((prev) => prev + 1);
    },
    onError: (error) => {
      setLoading(false);
      throw error;
    },
  });

  useEffect(() => {
    if (categoryId) {
      testApi.getTestSubject(1, categoryId).then((res) => {
        setSubject(res.data);
        setSubjectOptions(
          res.data.map((el: Subject) => ({
            optionName: el.name,
            optionValue: el.name,
            optionId: el.id,
          }))
        );
      });
    }
  }, [categoryId]);

  const categories = data?.data?.map((el: Category) => ({
    optionName: el.name,
    optionValue: el.name,
    optionId: el.id,
  }));

  const handleCategory = (id: number, category: string) => {
    setcategoryId(id);
    setTestCategory(category);
  };

  const handleSubject = (id: string) => {
    setTestId(Number(id));
    setSubjectId(Number(id));
    setCode(subject.filter((el: Subject) => el.id.toString() == id)[0]?.code);
  };

  const handleDescription = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    mutate({
      subjectId,
      code,
      description,
      categoryId,
      institution: 1,
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      {isLoading ? (
        <ComponentLoader />
      ) : (
        <>
          <CredusSelect
            options={categories}
            placeholder="e.g  Foundational"
            label="Exam Category"
            onChange={(value) =>
              handleCategory(
                categories?.filter(
                  (el: OptionType) => el.optionValue == value
                )[0]?.optionId,
                categories?.filter(
                  (el: OptionType) => el.optionValue == value
                )[0]?.optionValue
              )
            }
          />
          <CredusSelect
            options={subjectOptions}
            placeholder="e.g  Economics"
            label="Test"
            onChange={(value) =>
              handleSubject(
                subjectOptions?.filter(
                  (el: OptionType) => el.optionValue == value
                )[0]?.optionId
              )
            }
          />
          <CredusInput
            label="code"
            placeholder="e.g  FD/001"
            value={code}
            disabled
          />
          <CredusTextArea label="Description*" onChange={handleDescription} />
          <FooterDiv>
            <CredusButton variant="secondary">Cancel</CredusButton>
            <CredusButton type="submit" disabled={loading}>
              {loading ? 'loading' : 'Save and Continue'}
            </CredusButton>
          </FooterDiv>
        </>
      )}
    </Form>
  );
};
const QuestionTemplate = ({
  setTestReUpload,
  setCreateTest,

  TestId,
}: QuestionTemplateProps) => {
  const [loading, setLoading] = useState(false);
  const [File, setFile] = useState<File>();
  const { setTestData } = useContext(TestContext);

  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const { mutate } = useMutation(testApi.uploadQuestionFile, {
    onMutate: () => setLoading(true),
    onSuccess: (data) => {
      setTestData((prev) => ({ ...prev, questions: data?.data }));
      setTimeout(() => {
        setLoading(false);
        setCreateTest(false);
        setTestReUpload(true);
      }, 2000);
    },
    onError: (error) => {
      setLoading(false);
      throw error;
    },
  });

  useEffect(() => {
    if (File) {
      const formData = objectToFormData({
        TestId,
        File,
        InstitutionId: 1,
      });
      mutate(formData);
    }
  }, [File]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.target.files?.[0];
    setFile(fileUploaded);
  };

  const handleFileUpload = () => {
    hiddenFileInput?.current?.click();
  };

  const handleDownload = () => {
    saveAs(
      `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`,
      'Credus Exam Upload Format.xlsx'
    );
  };

  return (
    <TemplateDiv>
      {loading && <PageLoader loaderText="Uploading questions..." />}
      <CredusText size="md">
        Questions are imported by downloading and completing the excel template
      </CredusText>

      <div>
        <CredusButton variant="secondary" size="small" onClick={handleDownload}>
          Download template
        </CredusButton>
      </div>

      <CredusText size="md">
        If you’ve already completed the template, use the ‘select file’ button
        to import your question
      </CredusText>
      <FooterDiv>
        <CredusButton variant="secondary">Cancel</CredusButton>
        <CredusButton onClick={handleFileUpload}>Select file</CredusButton>
        <input
          type="file"
          ref={hiddenFileInput}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
      </FooterDiv>
    </TemplateDiv>
  );
};
const CreateTestModal = ({
  createTest,
  setCreateTest,
  setTestReUpload,
}: CreateTestProps) => {
  const [step, setStep] = useState(0);
  const [TestId, setTestId] = useState(0);

  return (
    <>
      <Modal
        title={
          <CredusText size="md" weight="medium">
            Import Test
          </CredusText>
        }
        open={createTest}
        footer=""
        onCancel={() => setCreateTest(false)}
      >
        <>
          {
            [
              <ExamCategory setStep={setStep} setTestId={setTestId} />,
              <QuestionTemplate
                setTestReUpload={setTestReUpload}
                setCreateTest={setCreateTest}
                TestId={TestId}
              />,
            ][step]
          }
        </>
      </Modal>
    </>
  );
};

export default CreateTestModal;

const FooterDiv = styled.div`
  display: flex;
  padding-top: 2rem;
  width: 100%;
  justify-content: flex-end;
  gap: 1rem;
`;

const Form = styled.form`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const TemplateDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  padding-top: 2.5rem;
  gap: 1.5rem;
`;
